import { Text } from 'designSystem/components/Text'
import {
  ToggleGroup,
  ToggleGroupItem,
} from 'designSystem/components/ToggleGroup'
import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  padding: 0.5rem;
`

const Choices = styled(ToggleGroup)`
  width: 100%;
  padding: 0.125rem;
  gap: 0.125rem;
  border: 1px solid var(--border);
  background: var(--muted);
`

const Choice = styled(ToggleGroupItem)`
  flex: 1;
  min-width: 0;
  color: var(--muted-foreground);

  && {
    border-radius: var(--radius-sm);
  }

  &[data-state='on'] {
    background: var(--accent);
    color: var(--accent-foreground);
  }
`

interface AccountMenuChoiceProps {
  label: string
  value: string
  onValueChange: (value: string) => void
  options: ReadonlyArray<{
    value: string
    label: string
    accessibleLabel: string
    lang?: string
  }>
}

export function AccountMenuChoice({
  label,
  value,
  onValueChange,
  options,
}: AccountMenuChoiceProps) {
  const labelId = React.useId()

  const handleValueChange = (nextValue: string) => {
    if (nextValue) onValueChange(nextValue)
  }

  return (
    <Container>
      <Text id={labelId} variant='caption' color='muted' weight='medium'>
        {label}
      </Text>
      <Choices
        type='single'
        size='default'
        aria-labelledby={labelId}
        value={value}
        onValueChange={handleValueChange}>
        {options.map((option) => (
          <Choice
            key={option.value}
            value={option.value}
            lang={option.lang}
            aria-label={option.accessibleLabel}>
            {option.label}
          </Choice>
        ))}
      </Choices>
    </Container>
  )
}
